import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/seo/Seo";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="min-h-[80vh] flex items-center justify-center px-6 md:px-12 pt-28 md:pt-32 bg-bone"
    >
      <Seo
        path="/404"
        title="Page not found"
        description="That page is out of view. Return to the journal, the rituals, or the shop."
        noindex
      />
      <div className="max-w-xl text-center">
        <p className="overline mb-8 text-stone">Out of view · 404</p>
        <h1 className="font-display text-5xl md:text-7xl font-light leading-[0.95] tracking-[-0.02em] text-ink mb-8">
          A quiet <em className="italic text-moss">absence.</em>
        </h1>
        <p className="text-charcoal text-base md:text-lg font-light leading-[1.7] mb-12">
          What you were looking for is not at this address. Begin again with the
          journal, the rituals, or the shop — each holds something worth the detour.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-6">
          <Link
            to="/"
            className="text-[0.72rem] tracking-[0.24em] uppercase bg-ink text-bone px-6 py-3 hover:bg-charcoal transition-colors"
            data-testid="not-found-home"
          >
            Return home
          </Link>
          <Link
            to="/journal"
            className="text-[0.72rem] tracking-[0.24em] uppercase border border-hairline text-charcoal px-6 py-3 hover:border-ink hover:text-ink transition-colors"
            data-testid="not-found-journal"
          >
            The Journal
          </Link>
          <Link
            to="/shop"
            className="text-[0.72rem] tracking-[0.24em] uppercase border border-hairline text-charcoal px-6 py-3 hover:border-ink hover:text-ink transition-colors"
            data-testid="not-found-shop"
          >
            The Shop
          </Link>
        </div>
      </div>
    </div>
  );
}
